import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function MumbaitopandharpurAkkalkotTuljapurCabBooking() {



    const cardData = {





keyword: "Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",

headingDescription: "Shreesha Tours & Travels provides comfortable and reliable Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking services for devotees, families, and travelers planning religious tours across Maharashtra. We offer customized pilgrimage cab packages covering famous spiritual destinations including Shri Vitthal Rukmini Temple in Pandharpur, Shri Swami Samarth Maharaj Temple in Akkalkot, and Tulja Bhavani Temple in Tuljapur. Our chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and Tempo Traveller vehicles ensure a safe, peaceful, and comfortable journey for individuals, families, and large groups. With experienced drivers, well-maintained cars, flexible travel plans, transparent pricing, doorstep pickup from Mumbai, and 24/7 customer support, Shreesha Tours & Travels makes your Maharashtra pilgrimage tour convenient and hassle-free. Whether you need a one-way cab, round trip, multi-day religious package, or customized temple tour, we provide dependable transportation with complete comfort and convenience.",

topPlaces: [
  {
    title: "Mumbai to Pandharpur",
    description: "Pandharpur is one of Maharashtra's most important pilgrimage destinations, famous for the Shri Vitthal Rukmini Temple and the annual Ashadhi Ekadashi Wari pilgrimage. Devotees from Mumbai frequently book comfortable cabs for a peaceful spiritual journey."
  },
  {
    title: "Mumbai to Akkalkot",
    description: "Akkalkot is a renowned religious destination known for Shri Swami Samarth Maharaj Temple. Thousands of devotees visit this sacred place every year, and cab services provide convenient travel for families and senior citizens."
  },
  {
    title: "Mumbai to Tuljapur",
    description: "Tuljapur is famous for the historic Tulja Bhavani Temple, one of Maharashtra's most respected Shakti Peethas. Travelers prefer private cab bookings for comfortable and flexible temple visits."
  },
  {
    title: "Mumbai to Solapur",
    description: "Solapur is a major city near Pandharpur, Akkalkot, and Tuljapur, known for Siddheshwar Temple, textile industries, and cultural attractions. It is an important stop during Maharashtra pilgrimage tours."
  },
  {
    title: "Mumbai to Jejuri",
    description: "Jejuri is a famous pilgrimage town known for the Khandoba Temple and vibrant religious traditions. It is a popular destination for devotees traveling across Maharashtra."
  },
  {
    title: "Mumbai to Alandi",
    description: "Alandi is a sacred pilgrimage place associated with Sant Dnyaneshwar Maharaj. Devotees visit the Samadhi Mandir throughout the year, making it an important religious destination."
  },
  {
    title: "Mumbai to Dehu",
    description: "Dehu is the birthplace of Sant Tukaram Maharaj and an important spiritual destination near Pune. It is visited by devotees interested in Maharashtra's Bhakti tradition."
  },
  {
    title: "Mumbai to Bhimashankar",
    description: "Bhimashankar is one of the twelve Jyotirlingas and a famous pilgrimage destination surrounded by Sahyadri forests. It is ideal for religious tours combined with nature travel."
  },
  {
    title: "Mumbai to Trimbakeshwar",
    description: "Trimbakeshwar near Nashik is one of the twelve Jyotirlinga temples and holds great religious importance. Families and devotees prefer private cabs for a comfortable temple visit."
  },
  {
    title: "Mumbai to Grishneshwar",
    description: "Grishneshwar Temple near Ellora is one of the twelve Jyotirlingas and an important spiritual destination in Maharashtra. Cab services provide convenient travel for pilgrimage groups and families."
  }
],




"services": [
  {
    "name": "Mumbai to Pandharpur Cab",
    "description": "Book Mumbai to Pandharpur Cab for a comfortable and reliable pilgrimage journey with experienced chauffeurs and well-maintained AC vehicles. Travel safely to Pandharpur temple with Sedan, Ertiga, Innova, Innova Crysta, and SUV cab options available for family trips, group travel, and religious tours."
  },
  {
    "name": "Mumbai to Akkalkot Cab",
    "description": "Choose Mumbai to Akkalkot Cab for convenient and peaceful religious travel with professional drivers and comfortable vehicles. Enjoy hassle-free transportation for Akkalkot Swami Samarth Darshan with flexible one way and round trip cab booking options."
  },
  {
    "name": "Mumbai to Tuljapur Cab",
    "description": "Book Mumbai to Tuljapur Cab for a safe and comfortable temple visit with experienced chauffeurs and premium travel facilities. Our cab services provide reliable transportation for Tulja Bhavani Darshan, family pilgrimages, and Maharashtra religious tours."
  },
  {
    "name": "Mumbai Pandharpur Akkalkot Tuljapur Tour Package",
    "description": "Explore Mumbai Pandharpur Akkalkot Tuljapur Tour Package with customized cab services covering famous religious destinations of Maharashtra. Travel comfortably with spacious vehicles, experienced drivers, flexible itineraries, and affordable tour packages designed for family and group pilgrimages."
  },
  {
    "name": "Mumbai to Pandharpur Taxi",
    "description": "Hire Mumbai to Pandharpur Taxi for smooth long-distance travel with clean AC cars, professional chauffeurs, and transparent pricing. Perfect for devotees, families, and groups planning Pandharpur temple visits with safe and comfortable transportation."
  },
  {
    "name": "Mumbai to Akkalkot Taxi",
    "description": "Reserve Mumbai to Akkalkot Taxi for reliable pilgrimage transportation with comfortable seating and skilled drivers. Enjoy a stress-free journey to Akkalkot with convenient pickup options and flexible travel plans."
  },
  {
    "name": "Mumbai to Tuljapur Taxi",
    "description": "Choose Mumbai to Tuljapur Taxi for affordable and dependable travel to Tuljapur Bhavani Temple. Get well-maintained vehicles, experienced chauffeurs, and customized cab solutions for solo travelers, families, and groups."
  },
  {
    "name": "Mumbai to Pandharpur Cab Booking",
    "description": "Complete Mumbai to Pandharpur Cab Booking easily with multiple vehicle choices and affordable travel packages. Enjoy doorstep pickup, professional drivers, comfortable journeys, and reliable support for your religious trip."
  },
  {
    "name": "Mumbai to Tuljapur Cab Service",
    "description": "Book Mumbai to Tuljapur Cab Service for safe and convenient temple travel with experienced chauffeurs and premium vehicles. Ideal for Tuljapur Darshan, family tours, and Maharashtra pilgrimage routes."
  },
  {
    "name": "Mumbai to Akkalkot Cab Service",
    "description": "Choose Mumbai to Akkalkot Cab Service for comfortable religious travel with reliable vehicles and professional drivers. Our services are suitable for Swami Samarth Darshan, family trips, and round trip pilgrimage journeys."
  },
  {
    "name": "Mumbai Religious Tour Cab",
    "description": "Book Mumbai Religious Tour Cab for customized temple tours across Maharashtra with comfortable vehicles and experienced drivers. Travel conveniently to famous pilgrimage destinations with flexible packages and reliable transportation services."
  },
  {
    "name": "Mumbai Temple Tour Taxi",
    "description": "Choose Mumbai Temple Tour Taxi for spiritual journeys covering popular temples and religious destinations. Enjoy safe travel with spacious cabs, professional chauffeurs, and customized sightseeing plans for devotees and families."
  },
  {
    "name": "Mumbai to Pandharpur Outstation Cab",
    "description": "Reserve Mumbai to Pandharpur Outstation Cab for reliable interstate and intercity travel with comfortable AC vehicles. Get professional chauffeur service, affordable fares, and flexible one way or round trip booking options."
  },
  {
    "name": "Mumbai to Tuljapur Darshan Cab",
    "description": "Book Mumbai to Tuljapur Darshan Cab for a peaceful pilgrimage experience with convenient pickup, comfortable vehicles, and experienced drivers. Perfect for devotees visiting Tulja Bhavani Temple with family and friends."
  },
  {
    "name": "Mumbai to Akkalkot Darshan Package",
    "description": "Choose Mumbai to Akkalkot Darshan Package for a complete religious tour experience with comfortable cab travel and flexible schedules. Enjoy hassle-free Swami Samarth temple visits with reliable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Pandharpur Innova Cab",
    "description": "Book Mumbai to Pandharpur Innova Cab for spacious and comfortable travel suitable for families and groups. Enjoy premium seating, experienced drivers, and a smooth journey for long-distance pilgrimage travel."
  },
  {
    "name": "Mumbai to Tuljapur Ertiga Cab",
    "description": "Choose Mumbai to Tuljapur Ertiga Cab for affordable group travel with spacious seating and comfortable interiors. Ideal for family temple visits, religious tours, and round trip journeys."
  },
  {
    "name": "Mumbai to Akkalkot Innova Crysta Cab",
    "description": "Reserve Mumbai to Akkalkot Innova Crysta Cab for luxury and comfortable pilgrimage travel. Enjoy premium interiors, experienced chauffeurs, and reliable transportation for families and groups visiting Akkalkot."
  },
  {
    "name": "Best Mumbai Temple Tour Cab",
    "description": "Book the Best Mumbai Temple Tour Cab for safe, comfortable, and reliable religious travel across Maharashtra. With premium vehicles, professional chauffeurs, flexible tour packages, and customized routes, enjoy a peaceful pilgrimage experience covering Pandharpur, Akkalkot, Tuljapur, and other famous temples."
  }
],
"tableData": [
  ["Mumbai to Pandharpur Cab", "Mumbai to Akkalkot Cab"],
  ["Mumbai to Tuljapur Cab", "Mumbai Pandharpur Akkalkot Tuljapur Tour Package"],
  ["Mumbai to Pandharpur Taxi", "Mumbai to Akkalkot Taxi"],
  ["Mumbai to Tuljapur Taxi", "Mumbai to Pandharpur Cab Booking"],
  ["Mumbai to Tuljapur Cab Service", "Mumbai to Akkalkot Cab Service"],
  ["Mumbai Religious Tour Cab", "Mumbai Temple Tour Taxi"],
  ["Mumbai to Pandharpur Outstation Cab", "Mumbai to Tuljapur Darshan Cab"],
  ["Mumbai to Akkalkot Darshan Package", "Mumbai to Pandharpur Innova Cab"],
  ["Mumbai to Tuljapur Ertiga Cab", "Mumbai to Akkalkot Innova Crysta Cab"],
  ["Best Mumbai Temple Tour Cab", ""]
],




whychoose: [
  {
    WhyChooseheading: "Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",
    WhyChoosedescription: "Plan a peaceful religious journey with Shreesha Travels from Mumbai to Pandharpur, Akkalkot, and Tuljapur. Our chauffeur-driven cab services provide comfortable transportation for devotees, families, senior citizens, and groups visiting these famous pilgrimage destinations."
  },
  {
    WhyChooseheading: "Complete Pilgrimage Tour Travel Solution",
    WhyChoosedescription: "Cover multiple spiritual destinations in one convenient trip with customized cab packages from Mumbai to Pandharpur, Akkalkot, and Tuljapur without the hassle of arranging separate transportation."
  },
  {
    WhyChooseheading: "Comfortable Cars for Long Religious Journeys",
    WhyChoosedescription: "Select from Swift Dzire, Sedan, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles based on your family size, luggage, and travel requirements."
  },
  {
    WhyChooseheading: "Ideal for Family, Group & Senior Citizen Travel",
    WhyChoosedescription: "Our pilgrimage cab services are designed to provide relaxed and convenient journeys with comfortable seating, experienced drivers, and flexible travel schedules suitable for all age groups."
  },
  {
    WhyChooseheading: "Customized Route Planning as Per Your Schedule",
    WhyChoosedescription: "Whether you need direct travel, sightseeing stops, temple visits, overnight stays, or return journey arrangements, we create travel plans according to your requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Maharashtra Pilgrimage Routes",
    WhyChoosedescription: "Our drivers have knowledge of Maharashtra highways and pilgrimage routes, helping passengers enjoy a safe and smooth journey from Mumbai to Pandharpur, Akkalkot, and Tuljapur."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "Choose one-way cab services, round-trip bookings, multi-day pilgrimage packages, or complete Maharashtra temple tour packages based on your travel plan."
  },
  {
    WhyChooseheading: "Reliable Pilgrimage Cab Service by Shreesha Travels",
    WhyChoosedescription: "With transparent pricing, timely service, clean vehicles, and dedicated travel assistance, Shreesha Travels ensures a comfortable spiritual journey from Mumbai to important religious destinations."
  }
]

};

const faqData = [
  {
    question: "Do you provide Mumbai to Pandharpur Akkalkot Tuljapur cab packages?",
    answer: "Yes, we provide customized cab bookings from Mumbai covering Pandharpur, Akkalkot, and Tuljapur with flexible travel plans."
  },
  {
    question: "How many days are required for the Pandharpur Akkalkot Tuljapur tour?",
    answer: "The duration depends on your sightseeing requirements, temple visit timings, and return schedule. Customized multi-day packages are available."
  },
  {
    question: "Which vehicles are suitable for pilgrimage tours?",
    answer: "Sedan cars are suitable for small families, while Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers are preferred for larger groups."
  },
  {
    question: "Can senior citizens travel comfortably on this route?",
    answer: "Yes, our comfortable vehicles and experienced drivers make the journey convenient for senior citizens and families."
  },
  {
    question: "Do you provide pickup from any location in Mumbai?",
    answer: "Yes, pickup can be arranged from airports, railway stations, residential areas, hotels, and other locations across Mumbai."
  },
  {
    question: "Can I customize the temple visit itinerary?",
    answer: "Yes, you can customize the route with additional stops, sightseeing locations, and preferred travel timings."
  },
  {
    question: "Is round-trip cab booking available for this pilgrimage route?",
    answer: "Yes, round-trip cabs are available with flexible return dates and complete travel assistance."
  },
  {
    question: "Are overnight travel options available?",
    answer: "Yes, overnight departures and multi-day travel arrangements can be planned according to your convenience."
  },
  {
    question: "How is the fare calculated for Mumbai to Pandharpur Akkalkot Tuljapur cab?",
    answer: "The fare depends on vehicle type, number of days, total distance, route plan, waiting time, and additional destinations included."
  },
  {
    question: "How can I book Mumbai to Pandharpur Akkalkot Tuljapur Cab with Shreesha Travels?",
    answer: "Share your travel date, pickup location, passenger count, preferred vehicle, and tour plan to get a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Joshi",
    feedback: "The entire pilgrimage journey was arranged smoothly. The vehicle was comfortable, the driver was polite, and visiting multiple temples became much easier with proper travel planning.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Patil",
    feedback: "Our family trip from Mumbai to Pandharpur, Akkalkot, and Tuljapur was a wonderful experience. The comfortable cab and professional service made the spiritual journey relaxing.",
    rating: 5
  }
];








    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-pandharpur-akkalkot-tuljapur-cab-booking.webp",
  "description":
    "Book Mumbai to Pandharpur Akkalkot Tuljapur Cab Booking with Shreesha Tours & Travels for comfortable and reliable pilgrimage tour taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for religious journeys, family trips, temple visits, and multi-city Maharashtra tours with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-pandharpur-akkalkot-tuljapur-cab-booking"
  }
};







    return (
        <div>

<Helmet>
  <title>Mumbai to Pandharpur Akkalkot Tuljapur Cab | Pilgrimage Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Pandharpur Akkalkot Tuljapur Cab with Shreesha Travels for safe and comfortable pilgrimage tour taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for temple visits, family trips, and Maharashtra religious tours with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Pandharpur Cab, Mumbai to Akkalkot Cab, Mumbai to Tuljapur Cab, Mumbai Pandharpur Akkalkot Tuljapur Cab Booking, Mumbai to Pandharpur Akkalkot Tuljapur Taxi, Pandharpur Akkalkot Tuljapur Tour Package, Mumbai Religious Tour Cab, Maharashtra Pilgrimage Cab Service, Mumbai Temple Tour Taxi, Mumbai Outstation Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default MumbaitopandharpurAkkalkotTuljapurCabBooking;